$(function () {

	// Variable Set
	const personChoices = {
		'men': {
			's': { 's': [6], 'm': [4, 5, 6], 'l': [6], 'll': [6] },
			'm': { 's': [4, 5], 'm': [4, 5], 'l': [1, 2, 4, 5], 'll': [3, 4, 5] },
			'l': { 's': [1, 2], 'm': [1, 2, 4, 5], 'l': [1, 2], 'll': [1, 2, 3] },
			'll': { 's': [3], 'm': [3, 4, 5], 'l': [1, 2, 3], 'll': [3] },
			'ALL': [1, 2, 3, 4, 5, 6]
		},
		'women': {
			's': { 's': [7, 9, 11], 'm': [7, 9, 11], 'l': [7, 9, 11], 'll': [7, 9, 11] },
			'm': { 's': [9, 10, 11], 'm': [10, 11], 'l': [10, 12], 'll': [8, 10] },
			'l': { 's': [9, 12], 'm': [10, 11, 12], 'l': [12], 'll': [8, 12] },
			'll': { 's': [8], 'm': [8, 10, 11], 'l': [8, 12], 'll': [8] },
			'ALL': [7, 8, 9, 10, 11, 12]
		},
	};

	const sizeDefault = {
		men: {
			top: 'm',
			bottom: 'm',
		},
		women: {
			top: 'm',
			bottom: 'm',
		},
	};

	// Swiper Clone Create
	$("#model_wear").after('<div id="model_wear_clone" style="display: none;"></div>');
	$("#model_wear_clone").append($("#model_wear .swiper-wrapper").clone());
	$("#model_wear_clone").append($("#model_wear .model_desc").clone());


	const sizeChange = () => {
		// Value Get
		const gender = $('.gender-select input:radio:checked').val().toLowerCase();
		const tsize = $('.product-powersuit-size-set.' + gender + ' .product-powersuit-size-top input:radio:checked').val();
		const bsize = $('.product-powersuit-size-set.' + gender + ' .product-powersuit-size-bottom input:radio:checked').val();
		let persons;

		// Model Wear Reset
		$('#model_wear .swiper-wrapper').html($('#model_wear_clone .swiper-wrapper').html());
		$('#model_wear .model_desc').html($('#model_wear_clone .model_desc').html());

		// All Select
		if (gender != undefined) {

			// Person Get
			persons = (tsize != undefined && bsize != undefined ? personChoices[gender][tsize][bsize] : personChoices[gender]['ALL']);
			// Person Roop
			$('#model_wear [data-person]').each((i, el) => {
				if (!persons.includes(parseInt($(el).data('person')))) {
					$(el).remove();
				}
			});
		}

		// Swiper Reset
		modelCarousel.modelId = persons[0];
		modelCarousel.setSwiper();
		$('#model_wear .c-carousel-count__current').html('01');

	};

	const setSizeDefault = () => {
		const gender = $('.gender-select input:radio:checked').val().toLowerCase();
		['top', 'bottom'].forEach((cate) => {
			$('.product-powersuit-size-' + cate + ' input:radio:checked').prop('checked', false);
			$('.product-powersuit-size-set.' + gender)
				.find('.product-powersuit-size-' + cate)
				.find('input[value="' + sizeDefault[gender][cate] + '"]')
				.prop('checked', true);
		});
	};
	$(window).on('load', setSizeDefault);
	$(window).on('load', sizeChange);
	$('.gender-select input.radio-input').on('click', setSizeDefault);
	$('.gender-select input.radio-input, .size-select input.radio-input').on('click', sizeChange);

});
